/* Secret Scenta : Klarna (paiement en 3 fois sans frais) + pop-up d'accueil France.
   - Fiche produit : bloc style Skims sous les boutons d'achat, recalcule a chaque changement
     (variante, parfum ajoute a un diffuseur, achat ponctuel / abonnement) :
       "3 paiements de X sans frais avec Klarna. En savoir plus" (masque si abonnement),
       "Livraison offerte en France des 95 EUR d'achat" (seuil lu sur body[data-free-shipping-threshold]), delai,
       economie (prix barre + remise ensemble + abonnement).
     Source du total : le bouton "Ajouter au panier" (il affiche le prix reel de la selection).
   - "En savoir plus" (fiche produit + panier) : ouvre [data-ss-klarna-info].
   - Pop-up d'accueil [data-ss-welcome] : une fois par visiteur, apres les autres fenetres (Klaviyo, panier).
     Test : ajouter ?ss_welcome=1 a l'URL pour le forcer. */
(function () {
  'use strict';

  var KLARNA_MAX = 300000; /* centimes : plafond Klarna Pay in 3 en France (3 000 EUR) */
  var BADGE = 'https://x.klarnacdn.net/payment-method/assets/badges/generic/klarna.svg';
  var WELCOME_KEY = 'ss_welcome_seen_v1';
  var NBSP = String.fromCharCode(160);
  var ARROW = '<svg class="ss-pdp-mention__arrow" width="14" height="14" viewBox="0 0 14 14" aria-hidden="true" focusable="false"><path d="M3 3l8 8M11 4.5V11H4.5" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function klarnaEnabled() { return !!document.querySelector('[data-ss-klarna-info]'); }

  function fmt(cents, short) {
    var opts = { style: 'currency', currency: 'EUR' };
    if (short && cents % 100 === 0) { opts.minimumFractionDigits = 0; opts.maximumFractionDigits = 0; }
    try { return new Intl.NumberFormat('fr-FR', opts).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2).replace('.', ',') + NBSP + '€'; }
  }

  function parseCents(text) {
    var clean = String(text || '').replace(/[^0-9,€]/g, ' ');
    var m = clean.match(/[0-9][0-9 ]*,[0-9]{2}/);
    if (!m) return 0;
    return Math.round(parseFloat(m[0].replace(/ /g, '').replace(',', '.')) * 100);
  }
  function centsIn(el) { return el ? parseCents(el.textContent) : 0; }
  function setText(el, txt) { if (el && el.textContent !== txt) el.textContent = txt; }
  function setHidden(el, h) { if (el && el.hidden !== h) el.hidden = h; }

  function openDialog(d) {
    if (!d || d.open) return;
    if (typeof d.showModal === 'function') d.showModal(); else d.setAttribute('open', '');
  }
  function closeDialog(d) {
    if (!d) return;
    if (typeof d.close === 'function') d.close(); else d.removeAttribute('open');
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var opener = t.closest('[data-ss-klarna-open]');
    if (opener) {
      e.preventDefault();
      var info = document.querySelector('[data-ss-klarna-info]');
      if (!info) return;
      var amount = parseInt(opener.getAttribute('data-amount') || '0', 10);
      var ex = info.querySelector('[data-ss-klarna-example]');
      if (ex) {
        if (amount > 0) {
          ex.innerHTML = 'Pour ' + fmt(amount) + ', <strong>3 paiements de ' + fmt(Math.floor(amount / 3)) + '</strong>.';
          ex.hidden = false;
        } else {
          ex.hidden = true;
        }
      }
      openDialog(info);
      return;
    }
    var closer = t.closest('[data-ss-dialog-close]');
    if (closer) { closeDialog(closer.closest('dialog')); return; }
    if (t.matches('dialog.ss-klarna-info, dialog.ss-welcome')) {
      var r = t.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) closeDialog(t);
    }
  });

  /* Fiche produit */
  function getPdp() { return document.querySelector('.pdp--journey') || document.querySelector('[data-pdp]'); }

  function shippingThreshold() {
    var t = parseFloat((document.body && document.body.getAttribute('data-free-shipping-threshold')) || '95');
    return Math.round((isNaN(t) ? 95 : t) * 100);
  }

  function readPdp(pdp) {
    var price = pdp.querySelector('.pdp__price');
    var now = centsIn(price && (price.querySelector('.money-now') || price.querySelector('.pdp__price-value')));
    var was = centsIn(price && price.querySelector('.money-was'));
    var total = centsIn(pdp.querySelector('.pdp__atc')) || centsIn(pdp.querySelector('[data-selection-total]')) || now;
    var pick = pdp.querySelector('.scent-pick[aria-pressed="true"]');
    var addon = centsIn(pick);
    var saving = (was > now ? was - now : 0) + (now > 0 ? Math.max(0, now + addon - total) : 0);
    var plan = pdp.querySelector('form [name="selling_plan"]');
    var sub = !!(plan && plan.value && !plan.disabled) ||
      !!(pick && pdp.querySelector('input[name="diffuser_scent_purchase"][value="subscription"]:checked'));
    return { total: total, saving: saving, sub: sub };
  }

  function buildMention() {
    var el = document.createElement('div');
    el.className = 'ss-pdp-mention';
    el.setAttribute('data-ss-pdp-mention', '');
    el.innerHTML =
      '<p class="ss-klarna-line" data-ss-klarna-line hidden><span>3 paiements de <strong data-ss-klarna-per></strong> sans frais avec</span>' +
      '<img src="' + BADGE + '" alt="Klarna" width="45" height="19">' +
      '<button type="button" class="ss-klarna-more" data-ss-klarna-open>En savoir plus</button></p>' +
      '<div class="ss-pdp-mention__info">' + ARROW +
      '<p class="ss-pdp-mention__ship" data-ss-ship></p>' +
      '<p>Expédiée sous 48' + NBSP + 'à' + NBSP + '72' + NBSP + 'h ouvrées, <span class="ss-nowrap">livrée en 1 à 2 jours</span></p>' +
      '<p class="ss-pdp-mention__saving" data-ss-saving hidden></p>' +
      '</div>';
    return el;
  }

  function pdpMention() {
    if (!klarnaEnabled()) return;
    var pdp = getPdp();
    if (!pdp) return;
    var anchor = pdp.querySelector('.pdp__buy') || pdp.querySelector('.pdp__price');
    if (!anchor) return;
    var box = pdp.querySelector('[data-ss-pdp-mention]');
    if (!box) box = buildMention();
    if (anchor.nextElementSibling !== box) anchor.insertAdjacentElement('afterend', box);

    var d = readPdp(pdp);
    var line = box.querySelector('[data-ss-klarna-line]');
    var showKlarna = d.total > 0 && d.total <= KLARNA_MAX && !d.sub;
    if (showKlarna) {
      setText(line.querySelector('[data-ss-klarna-per]'), fmt(Math.floor(d.total / 3)));
      var more = line.querySelector('[data-ss-klarna-open]');
      if (more.getAttribute('data-amount') !== String(d.total)) more.setAttribute('data-amount', String(d.total));
    }
    setHidden(line, !showKlarna);

    setText(box.querySelector('[data-ss-ship]'), 'Livraison offerte en France dès ' + fmt(shippingThreshold(), true) + ' d’achat');

    var sav = box.querySelector('[data-ss-saving]');
    if (d.saving > 0) setText(sav, 'Vous économisez ' + fmt(d.saving));
    setHidden(sav, !(d.saving > 0));
  }

  /* setTimeout plutot que requestAnimationFrame : rAF est suspendu dans certains navigateurs integres / onglets en arriere-plan */
  var timer = 0;
  function schedulePdp() {
    if (timer) return;
    timer = window.setTimeout(function () { timer = 0; pdpMention(); }, 30);
  }

  function initPdp() {
    pdpMention();
    var pdp = getPdp();
    if (!pdp) return;
    document.addEventListener('change', function (e) {
      var p = getPdp();
      if (p && e.target && p.contains(e.target)) schedulePdp();
    });
    if (!window.MutationObserver) return;
    var root = pdp.closest('.shopify-section') || pdp.parentNode;
    new MutationObserver(schedulePdp).observe(root, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'aria-pressed'] });
  }

  /* Pop-up d'accueil */
  function welcomeSeen() {
    try { return window.localStorage.getItem(WELCOME_KEY) === '1'; } catch (e) { return true; }
  }
  function markWelcomeSeen() {
    try { window.localStorage.setItem(WELCOME_KEY, '1'); } catch (e) {}
  }
  function otherWindowOpen(welcome) {
    var open = document.querySelectorAll('dialog[open]');
    for (var i = 0; i < open.length; i++) { if (open[i] !== welcome) return true; }
    var els = document.querySelectorAll('[role="dialog"], [aria-modal="true"]');
    for (var j = 0; j < els.length; j++) {
      var el = els[j];
      if (el.tagName === 'DIALOG' || welcome.contains(el)) continue;
      if (el.closest('#shopify-pc__banner') || /^shopify-pc/.test(el.id || '')) continue;
      var r = el.getBoundingClientRect();
      if (r.width > 0 && r.height > 0 && window.getComputedStyle(el).visibility !== 'hidden') return true;
    }
    return false;
  }
  function initWelcome() {
    var welcome = document.querySelector('[data-ss-welcome]');
    if (!welcome) return;
    var forced = /[?&]ss_welcome=1/.test(window.location.search);
    if (!forced && (welcomeSeen() || (window.Shopify && window.Shopify.designMode))) return;
    var tries = 0;
    function attempt() {
      if (otherWindowOpen(welcome)) {
        tries += 1;
        if (tries < 40) window.setTimeout(attempt, 1500);
        return;
      }
      openDialog(welcome);
      markWelcomeSeen();
    }
    window.setTimeout(attempt, forced ? 300 : 1500);
  }

  function init() { initPdp(); initWelcome(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', pdpMention);
})();